import axios, { isAxiosError } from 'axios'
import { appConfig } from '../config/app'

export interface ApiErrorDetails {
  message: string
  status: number | null
  validation: Record<string, string[]>
}

interface LaravelErrorPayload {
  message?: string
  errors?: Record<string, string[]>
}

const baseURL = import.meta.env.VITE_API_BASE_URL?.trim() || appConfig.defaultApiBaseUrl

export const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export const apiOrigin = new URL(baseURL).origin

export function normalizeApiError(error: unknown): ApiErrorDetails {
  if (isAxiosError<LaravelErrorPayload>(error)) {
    return {
      message: error.response?.data?.message ?? error.message ?? 'The request could not be completed.',
      status: error.response?.status ?? null,
      validation: error.response?.data?.errors ?? {},
    }
  }

  return {
    message: error instanceof Error ? error.message : 'An unexpected error occurred.',
    status: null,
    validation: {},
  }
}

apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (isAxiosError(error) && error.response?.status === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'))
    }

    return Promise.reject(error)
  },
)
